import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import CONTRACTS from '../../constants/CONTRACTS';

interface State {
  termInfo: {
    termId: string;
    termVersion: number;
    content: string;
    isFrontendTermAccepted: boolean;
    hasAcceptedTermVersion: boolean;
  },
  contractInfo: {
    contractId: string;
    contractVersion: number;
    content: string;
    hasAcceptedContractVersion: boolean;
  },
  contractType: string;
  termType: string;
};

const initialState: State = {
  termInfo: {
    hasAcceptedTermVersion: false,
    isFrontendTermAccepted: false,
    termId: null,
    termVersion: null,
    content: null
  },
  contractInfo: {
    hasAcceptedContractVersion: false,
    contractId: null,
    contractVersion: null,
    content: null
  },
  contractType: CONTRACTS.BASE,
  termType: 'TERMS_AND_CONDITIONS',
}

const consents = createSlice({
  name: 'consents',

  initialState,

  reducers: {
    termFinished(state, action: PayloadAction<any>) {
      state.termInfo = action.payload.termInfo;
    },

    contractFinished(state, action: PayloadAction<any>) {
      state.contractInfo = action.payload.contractInfo;
    },

    termAccepted(state) {
      state.termInfo.isFrontendTermAccepted = true;
      state.termInfo.hasAcceptedTermVersion = true;
    },

    contractAccepted(state) {
      state.contractInfo.hasAcceptedContractVersion = true;
    },

    setContractType(state, action: PayloadAction<any>) {
      state.contractType = action.payload.contractType;
    },
  },
});

export const {
  termFinished,
  contractFinished,
  termAccepted,
  contractAccepted,
  setContractType,
} = consents.actions;

export default consents.reducer;
